/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Lifetime_TimeInputs */

const en_us2_progress_extra_lifetime_time = /** @type {(inputs: Progress_Extra_Lifetime_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`training`)
};

const pt_br2_progress_extra_lifetime_time = /** @type {(inputs: Progress_Extra_Lifetime_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de treino`)
};

const es_419_progress_extra_lifetime_time = /** @type {(inputs: Progress_Extra_Lifetime_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entrenando`)
};

const pt_pt2_progress_extra_lifetime_time = /** @type {(inputs: Progress_Extra_Lifetime_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de treino`)
};

const fr_fr2_progress_extra_lifetime_time = /** @type {(inputs: Progress_Extra_Lifetime_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`d'entraînement`)
};

const de_de2_progress_extra_lifetime_time = /** @type {(inputs: Progress_Extra_Lifetime_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

const it_it2_progress_extra_lifetime_time = /** @type {(inputs: Progress_Extra_Lifetime_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`di allenamento`)
};

/**
* | output |
* | --- |
* | "training" |
*
* @param {Progress_Extra_Lifetime_TimeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_lifetime_time = /** @type {((inputs?: Progress_Extra_Lifetime_TimeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Lifetime_TimeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_lifetime_time(inputs)
	if (locale === "es-419") return es_419_progress_extra_lifetime_time(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_lifetime_time(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_lifetime_time(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_lifetime_time(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_lifetime_time(inputs)
	return en_us2_progress_extra_lifetime_time(inputs)
});
export { progress_extra_lifetime_time as "progress-extra.lifetime_time" }